import { loose } from '../helpers';
import { z } from 'zod';

export type CustomerDietTypes = z.infer<typeof CustomerDietTypes>;
export type CustomerIntoleranceTypes = z.infer<typeof CustomerIntoleranceTypes>;
export type CustomerGoalTypes = z.infer<typeof CustomerGoalTypes>;
export type CustomerHealthSettings = z.infer<typeof CustomerHealthSettings>;

export const CustomerDietTypes = z.enum(['vegetarian', 'vegan', 'regional', 'organic']);
export const CustomerIntoleranceTypes = z.enum(['glutenFree', 'lactoseFree']);
export const CustomerGoalTypes = z.enum([
    'moreKalories',
    'lessKalories',
    'buildMuscle',
    'lessSugar',
    'lessSalt',
    'lessFat',
    'moreProtein',
    'moreFiber',
    'lessMeat',
]);

export const CustomerHealthProperties = {
    diet: CustomerDietTypes,
    intolerances: CustomerIntoleranceTypes,
    goals: CustomerGoalTypes,
};

export const CustomerHealthSettings = z.object({
    diet: z.array(loose(CustomerDietTypes)).nullish(),
    intolerances: z.array(loose(CustomerIntoleranceTypes)).nullish(),
    goals: z.array(loose(CustomerGoalTypes)).nullish(),
});
